/* unplugin-vue-components disabled */import { render } from "./Customer-Display.vue?vue&type=template&id=7e364fec&scoped=true&ts=true"
import script from "./Customer-Display.vue?vue&type=script&lang=ts"
export * from "./Customer-Display.vue?vue&type=script&lang=ts"

import "./Customer-Display.vue?vue&type=style&index=0&id=7e364fec&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e364fec"]])

export default __exports__